/**
 * Image Grid with Content block – styles only.
 */
import './style.scss';
